import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { bool, func, shape, arrayOf } from "prop-types";

import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { actions as sessionActions } from "reducers/session";
import { actions as settingsActions, selectors as settingsSelectors } from "reducers/settings";

import Notification from "pages/_components/Notification";
import Step4Content from "pages/login/_components/Step4Content";
import MainContainer from "pages/_components/MainContainer";
import { push } from "connected-react-router";
import I18n from "pages/_components/I18n";

class LoginStep4 extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        dispatch: func.isRequired,
        isMobile: bool.isRequired,
        loginTermsAndConditions: shape({}).isRequired,
        documents: arrayOf(shape({})),
    };

    static defaultProps = {
        documents: [],
    };

    componentDidMount() {
        const { dispatch, loginTermsAndConditions } = this.props;

        if (!loginTermsAndConditions) {
            dispatch(push("/desktop"));
        } else {
            dispatch(settingsActions.loadDocumentsRequest("termsAndConditions"));
        }
    }

    onCancel = () => {
        const { dispatch } = this.props;
        dispatch(loginActions.reset());
        dispatch(sessionActions.logout());
        dispatch(push("/"));
    };

    render() {
        const { isDesktop, isMobile, loginTermsAndConditions, documents } = this.props;

        return (
            <div className="terms_and_conditions">
                {isMobile && (
                    <header className="view-header header-simple">
                        <h1 className="text-center">
                            <I18n id="login.step4.header" />
                        </h1>
                    </header>
                )}
                <Notification scopeToShow="loginStep4" />
                <MainContainer className={classNames("onboarding")}>
                    {isDesktop && (
                        <h1 className="text-center">
                            <I18n id="login.step4.header" />
                        </h1>
                    )}
                    <Step4Content
                        isDesktop={isDesktop}
                        onCancel={this.onCancel}
                        termsAndConditions={loginTermsAndConditions?.body}
                        fileName={documents[0]?.fileNameKey}
                    />
                </MainContainer>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    loginTermsAndConditions: loginSelectors.getTermsAndConditions(state),
    documents: settingsSelectors.getDocuments(state),
});
export default connect(mapStateToProps)(LoginStep4);
